import { b as l } from "./reactive-element-BDpydG15.js";
import { render as c, noChange as a } from "../beacon-html.d/index.js";
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
class s extends l {
  constructor() {
    super(...arguments), this.renderOptions = { host: this }, this._$Do = void 0;
  }
  createRenderRoot() {
    var t, r;
    const e = super.createRenderRoot();
    return (r = (t = this.renderOptions).renderBefore) != null || (t.renderBefore = e.firstChild), e;
  }
  update(e) {
    const t = this.render();
    this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(e), this._$Do = c(t, this.renderRoot, this.renderOptions);
  }
  connectedCallback() {
    var e;
    super.connectedCallback(), (e = this._$Do) == null || e.setConnected(!0);
  }
  disconnectedCallback() {
    var e;
    super.disconnectedCallback(), (e = this._$Do) == null || e.setConnected(!1);
  }
  render() {
    return a;
  }
}
var i;
s._$litElement$ = !0, s.finalized = !0, (i = globalThis.litElementHydrateSupport) == null || i.call(globalThis, { LitElement: s });
const o = globalThis.litElementPolyfillSupport;
o == null || o({ LitElement: s });
const u = { _$AK: (n, e, t) => {
  n._$AK(e, t);
}, _$AL: (n) => n._$AL };
var d;
((d = globalThis.litElementVersions) != null ? d : globalThis.litElementVersions = []).push("4.0.5");
export {
  u as o,
  s
};
